<template>
  <div class="table" :class="[tableStatusClass, { selected: selected }]" @click="$emit('click')">
    <a class="table-container">
      <div class="card-header">
        <div class="customer-name">{{ table.customer_name }}</div>
        <div class="customer-name">#{{ table.serial_card }}</div>
      </div>
      <div class="card-info">
        <div class="info-item">
          <div class="info-label">{{ $t('restaurantSale.contactNumber') }}</div>
          <div class="info-value">{{ table.contact_number }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ $t('restaurantSale.maxTime') }}</div>
          <div class="info-value">{{ table.used_times + ' / ' + table.max_times }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ $t('restaurantSale.availableTime') }}</div>
          <div class="info-value">{{ table.available_times }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ $t('restaurantSale.expiryDate') }}</div>
          <div class="info-value">{{ table.expiry_date ? table.expiry_date : 'N/A' }}</div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'TableCard',
  props: {
    table: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    defaultCurrency: {
      type: String,
      default: ''
    }
  },
  computed: {
    tableStatusClass() {
      return 'available' // fallback
    },
  },
  methods: {},

  mounted() { },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  },
  data() {
    return {
      countdownInterval: null
    }
  }
}
</script>

<style scoped lang="scss">
.pos-counter .pos-counter-body .pos-counter-content .table-row .table {
  width: 25%;
  flex: 0 0 25%;

  @media (max-width: 75em) {

    /* ~992px */
    flex: 0 0 33.33%;
    /* 3 per row */
    width: 33.33%;
  }

  @media (max-width: 54em) {

    /* ~768px */
    flex: 0 0 50%;
    /* 2 per row */
    width: 50%;
  }

  @media (max-width: 37.5em) {

    /* ~480px */
    flex: 0 0 100%;
    /* 1 per row */
    width: 100%;
  }
}

.pos-counter .pos-counter-body .pos-counter-content .table-row .table .table-container .table-name {
  padding: 5px;
}

.pos-counter .pos-counter-body .pos-counter-content .table-row .table .table-container .table-name .no {
  font-size: 28px;
}

.table-container {
  font-family: 'Segoe UI';
  border-radius: 4px
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 20px;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  background-color: #00acac;
}

.customer-name {
  font-size: 16px;
  font-weight: 600;
  color: white;
  white-space: nowrap;
}

.status-badge {
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: uppercase;
}

.status-active {
  background: #e8f5e8;
  color: #4caf50;
}

.status-expired {
  background: #ffebee;
  color: #f44336;
}

.card-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  background: #f2f3f4;
  padding: 5px 15px 10px 15px;
  border-radius: 0 0 4px 4px;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 0.65rem;
  color: #666;
  margin-bottom: 0px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.info-value {
  font-size: 0.85rem;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
}

a:hover {
  text-decoration: none;
  cursor: default;
}
</style>
